<template>
	<div class="status-box">
		<div class="status-box__section">
			<h3 class="status-box__title">Current Item Info</h3>
			<p class="status-box__text" >
				<table>
					<tr>
						<td>Order #:</td>
						<td>{{ currItem.order_serial }}</td>
					</tr>
				</table>
			</p>
		</div>
		<div class="status-box__section">
			<h3 class="status-box__title">Current Item Thumbnail(s)</h3>
			<img
				class="status-box__thumbnail"
				:src=statusImg
				alt=""
			/>
		</div>
	</div>
</template>

<script>
import Vue from "vue";

import { mapActions } from "vuex";

export default Vue.extend({
	name: "StatusBox",
	data() {
		return {
			//status: ""
			
		};
	},
	components: {},
	methods: {
		...mapActions(["getData"])
	},
	computed: {
		status: {
			get() {
				return this.$store.getters.scanStatus;
			}
		},
		statusImg: {
			get() {
				return this.$store.getters.scanStatusImg;
			}
		},
		currItem: {
			get() {
				return this.$store.getters.infoCurrItem;
			}
		},
	},
	mounted() {
		this.getData();
	}
});
</script>

<style lang="scss" scoped>
.status-box {
	&__title {
		border-top-left-radius: 5px;
		border-top-right-radius: 5px;
		margin-bottom: 10px;
		text-align: center;
		font-weight: 600;
		font-size: 16px;
	}

	&__text {
		margin-bottom: 15px;
		text-align: center;
	}

	&__thumbnail {
		border: 1px solid $border-color;
		max-height: 315px;
		margin: 0 auto;
		display: block;
		width: auto;
	}
}
</style>